export default "__VITE_ASSET__CjNyp2oV__"